export const UI_GET_MASTER_DATA = 'UI_GET_MASTER_DATA';
export const UI_UPDATE_MASTER_DATA = 'UI_UPDATE_MASTER_DATA';
export const UI_SET_LOADER = 'UI_SET_LOADER';
export const UI_UPDATE_FROM_OFFER = 'UI_UPDATE_FROM_OFFER';
export const SET_UI_PROPERTY = 'SET_UI_PROPERTY';
export const GET_MARKDOWN_FILE = 'GET_MARKDOWN_FILE';
export const UI_GET_BASICS_BY_PARTNERID = 'UI_GET_BASICS_BY_PARTNERID';
